import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Alert,
  CircularProgress,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCrypto } from "../context/CryptoContext";

export default function ChangePassphraseDialog({ open, onClose }) {
  const { t } = useTranslation();
  const { changePass } = useCrypto();
  const [oldP, setOldP] = useState("");
  const [newP, setNewP] = useState("");
  const [newP2, setNewP2] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const close = () => {
    setOldP("");
    setNewP("");
    setNewP2("");
    setError("");
    setDone(false);
    onClose();
  };

  const submit = async () => {
    if (newP !== newP2) return setError(t("Passphrases do not match"));
    setBusy(true);
    setError("");
    try {
      await changePass(oldP, newP);
      setDone(true);
    } catch (e) {
      setError(
        e?.message === "WEAK_PASSPHRASE"
          ? t("Passphrase must be at least 12 characters")
          : t("Wrong passphrase or recovery key"),
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={busy ? undefined : close}
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle>{t("Change passphrase")}</DialogTitle>
      <DialogContent>
        {done ? (
          <Alert severity="success">
            {t("Passphrase changed. Your recovery key is unchanged.")}
          </Alert>
        ) : (
          <>
            <TextField
              autoFocus
              fullWidth
              type="password"
              margin="dense"
              label={t("Current passphrase")}
              value={oldP}
              onChange={(e) => setOldP(e.target.value)}
            />
            <TextField
              fullWidth
              type="password"
              margin="dense"
              label={t("New passphrase (min 12 characters)")}
              value={newP}
              onChange={(e) => setNewP(e.target.value)}
            />
            <TextField
              fullWidth
              type="password"
              margin="dense"
              label={t("Repeat new passphrase")}
              value={newP2}
              onChange={(e) => setNewP2(e.target.value)}
            />
            {error && (
              <Alert severity="error" sx={{ mt: 1 }}>
                {error}
              </Alert>
            )}
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={close} disabled={busy}>
          {done ? t("Close") : t("Cancel")}
        </Button>
        {!done && (
          <Button
            variant="contained"
            onClick={submit}
            disabled={busy || !oldP || !newP}
          >
            {busy ? <CircularProgress size={20} /> : t("Change")}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
